import React, {Component} from 'react';
import { connect } from "react-redux";
import { Form, ScrollView } from 'devextreme-react';
import * as apis from '../../utils/apis';
import axios from 'axios';
import notify from 'devextreme/ui/notify';
import {notificationTiming} from '../../utils/appConfig';

class AnswerQueryPopup extends Component {
    answerQuery = (params) => {

        var result = params.validationGroup.validate();
        
        if(result.isValid) {

        let data = {
            queryId: this.props.query.id,
            answer: this.props.query.response
        }
    
        axios.post('api/queries/answerQuery', data)
        .then(response => {  
            notify("Query resolved successfully.","success", notificationTiming);
            this.props.answerQueryHandler();
        })
        .catch(error => {
            console.log(error);
      
            notify(error.response.data,"error", notificationTiming);
           
           
        });
       }
    }

    render() {

        let formConfig = {
            items : [
                {
                    itemType: "group",
                    colCount: 6,
                    colSpan: 6,
                    items: [
                        
                        {
                            dataField: 'queryIdentifier',
                            colSpan: 1,
                            editorOptions: {
                                readOnly: true
                            },
                            label : { text: "Query #"},
                            
                        },
                        {
                            dataField: 'claimedBy',
                            colSpan: 1,                    
                            editorOptions: {
                                readOnly: true
                            },
                            label : { 
                                text: "Claimed by"},
                        },
                        {
                            dataField: 'queryStatusId',
                            colSpan: 1,
                            editorType: "dxSelectBox",
                            editorOptions: {
                                displayExpr: 'description',
                                valueExpr: 'id',
                                dataSource: apis.QueryStatusDataSource(this.props.user.access_token),
                                readOnly: true
                            },
                            label : { 
                                text: "Status"
                            },
                               
                        },
                        {
                            dataField: 'userGroupId',
                            colSpan: 1,
                            editorType: "dxSelectBox",
                            editorOptions: {
                                displayExpr: 'name',
                                valueExpr: 'id',
                                dataSource: apis.UserGroupDataSource(this.props.user.access_token),
                                readOnly: true
                            },
                            label : { 
                                text: "Responsible"
                            },
                               
                        },
                        {
                            dataField: 'raisedBy',
                            colSpan: 1,                    
                            editorOptions: {
                                readOnly: true
                            },
                            label : { 
                                text: "Raised by"},
                        },
                        {
                            dataField: 'dateOpened',
                            colSpan: 1,                    
                            editorType: "dxDateBox",
                            editorOptions: {
                                displayFormat: "dd/MM/y",
                                readOnly: true
                            },
                            label : { 
                                text: "Date Opened"},
                        },
                        
                        
                    ]
                },
             
                {
                    dataField: 'question',
                    colSpan: 6,
                    editorType: "dxTextArea",
                    editorOptions: {
                        height: "150px",
                        readOnly: true
                    },
                    label: {
                        text: "Question"
                    }

                },
                {
                    dataField: 'response',
                    colSpan: 6,
                    editorType: "dxTextArea",
                    editorOptions: {
                        height: "150px",
                        readOnly: false
                    },
                    label: {
                        text: "Response"
                    },
                    validationRules: [{
                        type: "required",
                        message: "Response Is Required"
                    },
                    {
                        type: "stringLength",
                        max: 2048,
                        message: "Response cannot exceed 2048 Characters"      
                    }]

                },
                {
                    itemType: "button",
                    horizontalAlignment: "right",
                    colSpan: 6,
                    buttonOptions: {
                        text: "Resolve Query",
                        type: "success",
                        useSubmitBehavior: false,
                        onClick: this.answerQuery
                    }
                },
                
               
            ]


    }

        let output = null;

       

        if(this.props.query) {
            output = 
            <ScrollView>
                <Form formData ={this.props.query} items={formConfig.items} colCount={6}>

                </Form>
            </ScrollView>
   
        }
        return (
            <div style={{height: '100%'}}>
            { output }
            </div>
          
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.oidc.user,
        query : state.queryDetail.rowData
    };
  }

export default connect(mapStateToProps,null)(AnswerQueryPopup)